import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute } from "@angular/router";
import { Patient } from "src/app/core/models/patient/patient";
import { FormService } from "src/app/core/services/v2/form.service";
import { PatientService } from "src/app/core/services/v2/patient.service";
import { PreviewDocumentComponent } from "src/app/shared/components/preview-document/preview-document.component";
import { PreviewImagesComponent } from "src/app/shared/components/preview-images/preview-images.component";

@Component({
  selector: "app-forms-sidebar",
  templateUrl: "./forms-sidebar.component.html",
  styleUrls: ["./forms-sidebar.component.scss"],
})
export class FormsSideBarComponent implements OnInit {
  formList: any = [];
  @Input() activeId: number;
  patientProfile: Patient;
  constructor(
    private activatedRoute: ActivatedRoute,
    private patientService: PatientService,
    private formService: FormService,
    public dialog: MatDialog
  ) { }
  ngOnInit(): void {
    this.getFormsByPatientId();
    this.getPatientDetailsById();
  }

  getPatientDetailsById() {
    this.patientService
      .getPatientDetailsById(this.activeId)
      .subscribe((details) => {
        this.patientProfile = details;
      });
  }

  previewDocument(location?: string, title?: string) {
    const dialogRef = location.endsWith("pdf")
      ? this.dialog.open(PreviewDocumentComponent, {
        maxWidth: "80%",
        panelClass: "preview-modal",
        disableClose: true,
        backdropClass: "preview-modal",
        data: {
          documentLocation: location,
          isFrame: true,
          documentTitle: title,
        },
        //   data: { documentTitle: title, documentLocation: location },
      })
      : this.dialog.open(PreviewImagesComponent, {
        width: "80%",
        disableClose: true,
        data: {
          documentTitle: title,
          images: [{ location: location, text: title }],
        },
      });
  }

  getFormsByPatientId() {
    this.formService.getPdfFormsByPatientId(this.activeId).subscribe((res) => {
      if (res && res.length > 0 && res[0].appointmentAssignedForms) {
        this.formList = res[0].appointmentAssignedForms;
      }
    });
  }
}
